/**
 * Options for the agent settings model select. A recorded model that is not one of
 * the fixed choices is offered as its own option, so the select shows what the row
 * holds instead of falling back to its first option (codex round 3 on PR #6315:
 * repository scripts configure gpt-5.1, which the fixed list does not carry).
 */
export const FIXED_MODEL_OPTIONS: ReadonlyArray<{ value: string; label: string }> = [
  { value: 'gpt-4o', label: 'GPT-4o' },
  { value: 'gpt-4o-mini', label: 'GPT-4o Mini' },
  { value: 'claude-3-opus', label: 'Claude 3 Opus' },
  { value: 'claude-3-sonnet', label: 'Claude 3 Sonnet' },
  { value: 'claude-3-haiku', label: 'Claude 3 Haiku' },
];

export function modelOptionsFor(recorded: string | null | undefined): Array<{ value: string; label: string }> {
  const fixed = [...FIXED_MODEL_OPTIONS];
  if (recorded && !fixed.some((o) => o.value === recorded)) {
    return [{ value: recorded, label: `${recorded} (recorded)` }, ...fixed];
  }
  return fixed;
}
